/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInsuranceClaim } from 'app/shared/model/insurance-claim.model';
import { InsuranceClaimStatus } from 'app/shared/model/enumerations/insurance-claim-status.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IInsuranceClaimHistory {
  id?: string;
  status?: keyof typeof InsuranceClaimStatus | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  claim?: IInsuranceClaim | null;
}

export const defaultValue: Readonly<IInsuranceClaimHistory> = {
  active: false,
};
